import { useMemo } from 'react';
import { MY_CONTENT_ROUTES } from '../../Base.constants';
import { UNRELEASED_FEATURES_ENABLED } from '../../appConfig';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';
import { LinkGroupRoute } from '../../components/LinkGroup/LinkGroup';

export interface UseGetMyContentRoutesResult {
  routes: LinkGroupRoute[];
}

const useGetMyContentRoutes = (): UseGetMyContentRoutesResult => {
  const { data: userPermissions } = useFetchUserPermissions();

  const routes = useMemo<LinkGroupRoute[]>(() => {
    return [
      ...(userPermissions?.hasAccessToMyContentArticles()
        ? [{ to: MY_CONTENT_ROUTES.articles(), label: 'Articles' }]
        : []),
      { to: MY_CONTENT_ROUTES.watchlists(), label: 'Watchlists' },
      { to: MY_CONTENT_ROUTES.searches, label: 'Searches' },
      ...(UNRELEASED_FEATURES_ENABLED ? [{ to: MY_CONTENT_ROUTES.covenants, label: 'Covenants' }] : []),
      { to: MY_CONTENT_ROUTES.managePreferences, label: 'Preferences' },
    ];
  }, [userPermissions]);

  return { routes };
};

export default useGetMyContentRoutes;
